import { TranslateService } from '@ngx-translate/core';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { reduceState, select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { setProfiles } from 'src/app/actions/profiles.actions';
import { AppConfig } from 'src/app/helpers/app.config';
import { Jobtype } from 'src/app/models/jobtype.model';
import { Pagination } from 'src/app/models/pagination.model';
import { Profile } from 'src/app/models/profile.model';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { fromJobtypes } from 'src/app/reducers/jobtypes.reducer';
import { fromProfiles } from 'src/app/reducers/profiles.reducer';
import { IdealProfileService } from 'src/app/services/ideal-profile.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Consultant } from 'src/app/models/consultant.model';

@Component({
  selector: 'ct-ideal-profiles',
  templateUrl: './ideal-profiles.component.html',
  styleUrls: ['./ideal-profiles.component.scss']
})
export class IdealProfilesComponent implements OnInit {

  @ViewChild('content') content;

  profileSearchForm: FormGroup = this.fb.group({
    jobtype: [''],
  });

  profiles$: Observable<Pagination<Profile>>;

  profileToDelete: Profile;
  modalRef: NgbModalRef;
  closeResult: string;

  jobtypes$: Observable<Jobtype[]>;

  currentConsultant: Consultant;

  constructor(
    public utilsService: UtilsService,
    private store: Store,
    private ngZone: NgZone,
    private fb: FormBuilder,
    private idealProfileService: IdealProfileService,
    private router: Router,
    private modal: NgbModal,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    localStorage.setItem('lastUrl', this.router.url);
    this.jobtypes$ = this.store.pipe(select(fromJobtypes.selectBusinessJobtypes));
    this.searchProfiles(1, null);
  }

  onSubmit() {
    this.searchProfiles(1, this.profileSearchForm.get('jobtype').value);
  }

  searchProfiles(page: number, jobtype: Jobtype) {
    this.ngZone.run(() => {
      this.store.pipe(select(fromConsultant.selectConsultantState)).subscribe(consultant => {
        this.currentConsultant = consultant;
        if (jobtype) {
          // si viene un jobtype seleccionado se muestran los perfiles de ese jobtype
          this.profiles$ = this.store.pipe(select(fromProfiles.selectProfilesByJobtype(jobtype.id)));

        } else {
          // si no viene un jobtype seleccionado se muestra toda la lista
          this.profiles$ = this.store.pipe(select(fromProfiles.selectProfilesState));

          this.idealProfileService.search(
            consultant.office.businessAreaIds,
            consultant.office.id,
            consultant.client.id,
            // page
          ).pipe(take(1)).subscribe(profiles => {
            profiles.map(profile => {
              if (profile.isUb) {
                profile.name = this.translateService.instant('JOBTYPES.' + (profile.jobtype?.randstadJobtype ?? 0))
              }
            })
            // TODO: adaptar para que funcione sin paginador
            const profilePage = {
              currentPage: 1,
              data: profiles,
              from: 1,
              lastPage: 1,
              perPage: profiles.length,
              to: profiles.length,
              total: profiles.length
            } as Pagination<Profile>;

            this.store.dispatch(setProfiles(profilePage));
          }, error => {
            this.utilsService.toast('error', 'CannotGetIdealProfiles', true, this.utilsService.getNacsData({ endpoint: 'GET' + AppConfig.settings.API + '/v2/idealProfiles', body: { companyTypeId: consultant.office.businessAreaIds, officeId: consultant.office.id }, error: { errorType: error.errorType, errorCode: error.errorCode, message: error.message } }));
          });
        }
      });
    });
  }

  showModalDeleteProfile(profile: Profile) {
    this.profileToDelete = profile;
    if (!this.modal.hasOpenModals()) {
      this.modalRef = this.modal.open(this.content, { ariaLabelledBy: 'Eliminar-Proceso', size: 'l', centered: true });
      this.modalRef.result.then((result) => {
        this.closeResult = 'Closed with: ' + result;
      }, (reason) => {
        this.closeResult = 'Dismissed ' + this.getDismissReason(reason);
      });
    }
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ' + reason;
    }
  }

  deleteProfile() {
    this.idealProfileService.delete(this.profileToDelete.id, this.currentConsultant.client.id).subscribe(result => {
      if (result) {
        this.utilsService.toast('success', 'IdealProfileDeleted');
        this.searchProfiles(1, null);
        this.modal.dismissAll('Cross click');
      } else {
        throw new Error();
      }
    }, error => {
      this.utilsService.toast('error', 'CannotDeleteIdealProfile', true, this.utilsService.getNacsData({ endpoint: 'DELETE' + AppConfig.settings.API + ' /candidates?origin=ct/idealprofiles/' + this.profileToDelete.id, body: '', error: { errorType: error.errorType, errorCode: error.errorCode, message: error.message } }));
    });
  }
}
